import { render } from "./ChatPagination.vue?vue&type=template&id=54956378"
import script from "./ChatPagination.vue?vue&type=script&lang=js"
export * from "./ChatPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__